export const projects = [
  {
    id: 1,
    title: "Python Convolutional Neural Network (CNN) for Image Classification",
    category: "Machine Learning",
    description:
      "This particular research is an exploration of artificial intelligence and deep neural networks in relation to image recognition. The foundation and basis for starting this research is the wide number of applications as well as the potential of this field. Before diving into understanding the facial/image recognition element there must be understanding of the building blocks that support it.",
    image: "",
    tags: ["Python", "Machine Learning", "Deep Learning", "Computer Vision"],
    // Tags marked true render highlighted (green border)
    highlights: ["Python", "Machine Learning"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/Facial_Regcognition_CNN",
    slug: "python-convolutional-neural-network-cnn-for-image-classification",
  },
  {
    id: 2,
    title: "In Development Unity RTS Project",
    category: "Game Development",
    description:
      "In development Unity RTS project focusing on creating a responsive and engaging gaming experience.",
    image: "",
    tags: ["Unity", "3D Modeling", "Game Design", "C#"],
    // Tags marked true render highlighted (green border)
    highlights: ["Unity", "3D Modeling"],
    link_title: "Devlog",
    link: "thejohnrobinson.com/devlog",
    slug: "unity-3d-game-development-project",
  },
  {
    id: 3,
    title: "Spring Boot RESTful API for E-commerce Platform",
    category: "Backend Development",
    description:
      "Building responsive, accessible interfaces that translate design into polished web experiences.",
    image: "",
    tags: ["Spring Boot", "RESTful API", "E-commerce", "Java"],
    // Tags marked true render highlighted (green border)
    highlights: ["Spring Boot", "RESTful API"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/SampleStoreFront",
    slug: "spring-boot-restful-api-for-e-commerce-platform",
  },
  {
    id: 4,
    title: "2026 Portfolio & Devlog",
    category: "Frontend Development",
    description:
      "Frontend development project showcasing a portfolio and devlog, highlighting skills in React, JavaScript, CSS, and HTML.",
    image: "",
    tags: ["React", "JavaScript", "CSS", "HTML"],
    // Tags marked true render highlighted (green border)
    highlights: ["React", "JavaScript"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/SampleStoreFront",
    slug: "2026-portfolio-devlog",
  },
  {
    id: 5,
    title: "2025 Portfolio",
    category: "Frontend Development",
    description:
      "Older frontend development project showcasing a portfolio, highlighting skills in React, JavaScript, CSS, and HTML.",
    image: "",
    tags: ["React", "JavaScript", "CSS", "HTML"],
    // Tags marked true render highlighted (green border)
    highlights: ["React", "JavaScript"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/portfolio_webpage_2025-2026",
    slug: "2025-portfolio",
  },
  {
    id: 6,
    title: "In Development Unity RPG Project",
    category: "Game Development",
    description:
      "In development Unity RPG dungeon crawler project focusing on creating a responsive and engaging gaming experience.",
    image: "",
    tags: ["Unity", "3D Modeling", "Game Design", "C#"],
    // Tags marked true render highlighted (green border)
    highlights: ["Unity", "3D Modeling"],
    link_title: "Devlog",
    link: "thejohnrobinson.com/devlog",
    slug: "unity-3d-game-development-project",
  },
  {
    id: 7,
    title: "Selenium Automated Email Appointment Scheduler",
    category: "Backend Development",
    description:
      "Building a Selenium automated email appointment scheduler for efficient calendar management.",
    image: "",
    tags: ["Selenium", "Automated Testing", "Email", "Java"],
    // Tags marked true render highlighted (green border)
    highlights: ["Selenium", "Automated Testing"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/Selenium-Email-Appointment-Scheduler",
    slug: "selenium-automated-email-appointment-scheduler",
  },
  {
    id: 8,
    title: "Godot Side-scroller platformer project",
    category: "Game Development",
    description:
      "A one stage Godot side-scroller platformer project focusing on creating a responsive and engaging gaming experience.",
    image: "",
    tags: ["Godot", "2D Graphics", "Game Design", "C#"],
    // Tags marked true render highlighted (green border)
    highlights: ["Godot", "2D Graphics"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/Godot-2D-Platformer",
    slug: "godot-side-scroller-platformer",
  },
  {
    id: 9,
    title: "Star-Type-Classification Data Science Project",
    category: "Data Science",
    description:
      "A data science project focused on classifying star types using machine learning techniques.",
    image: "",
    tags: ["Python", "Machine Learning", "Data Analysis", "Pandas"],
    // Tags marked true render highlighted (green border)
    highlights: ["Python", "Machine Learning"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/Star-Type-Classification",
    slug: "star-type-classification",
  },
  {
    id: 10,
    title: "Screen Pixel Change Detection",
    category: "Automation",
    description:
      "An automation project that detects changes in screen pixels and triggers actions based on those changes.",
    image: "",
    tags: ["Selenium", "Python", "Automation"],
    // Tags marked true render highlighted (green border)
    highlights: ["Python", "Automation"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/Screen-Change-Detector",
    slug: "Screen-Pixel-Change-Detection",
  },
  {
    id: 11,
    title: "ADB Appointment Scheduler for Android Devices",
    category: "Automation",
    description:
      "An automation project that uses ADB to schedule appointments on Android devices.",
    image: "",
    tags: ["Selenium", "Python", "Automation", "ADB", "Android"],
    // Tags marked true render highlighted (green border)
    highlights: ["Python", "Automation"],
    link_title: "GitHub Repository",
    link: "https://github.com/JohnARobinson/ADB-Appointment-Checker",
    slug: "ADB-Appointment-Scheduler",
  },
];
